import { useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { useLayoutStore } from '@store/LayoutStore';
import { shallow } from 'zustand/shallow';

export const useDebouncedSidebarWidth = () => {
  const [storeSidebarWidth, storeIsSidebarOpen] = useLayoutStore(
    (state) => [state.sidebarWidth, state.isSidebarOpen],
    shallow,
  );

  const [debouncedWidth, setDebouncedWidth] = useState<number>(storeSidebarWidth?.reduce((acc, w) => acc + w, 0) || 0);

  const debouncedSetWidth = useDebouncedCallback((width: number[]) => {
    const totalSidebarWidth = storeIsSidebarOpen ? width.reduce((acc, w) => acc + w, 0) : width[1];
    setDebouncedWidth(totalSidebarWidth);
  }, 50);

  debouncedSetWidth(storeSidebarWidth);

  return {
    totalSidebarWidth: debouncedWidth,
    isSidebarOpen: storeIsSidebarOpen,
  };
};
